/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TypeAttributes = {
    NotPublic: 'NotPublic',
    Public: 'Public',
    NestedPublic: 'NestedPublic',
    NestedPrivate: 'NestedPrivate',
    NestedFamily: 'NestedFamily',
    NestedAssembly: 'NestedAssembly',
    NestedFamAndAssem: 'NestedFamANDAssem',
    NestedFamOrAssem: 'NestedFamORAssem',
    SequentialLayout: 'SequentialLayout',
    ExplicitLayout: 'ExplicitLayout',
    LayoutMask: 'LayoutMask',
    Interface: 'Interface',
    Abstract: 'Abstract',
    Sealed: 'Sealed',
    SpecialName: 'SpecialName',
    RtSpecialName: 'RTSpecialName',
    Import: 'Import',
    Serializable: 'Serializable',
    WindowsRuntime: 'WindowsRuntime',
    UnicodeClass: 'UnicodeClass',
    AutoClass: 'AutoClass',
    CustomFormatClass: 'CustomFormatClass',
    HasSecurity: 'HasSecurity',
    ReservedMask: 'ReservedMask',
    BeforeFieldInit: 'BeforeFieldInit',
    CustomFormatMask: 'CustomFormatMask'
} as const;
export type TypeAttributes = typeof TypeAttributes[keyof typeof TypeAttributes];


export function TypeAttributesFromJSON(json: any): TypeAttributes {
    return TypeAttributesFromJSONTyped(json, false);
}

export function TypeAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeAttributes {
    return json as TypeAttributes;
}

export function TypeAttributesToJSON(value?: TypeAttributes | null): any {
    return value as any;
}

